import { render, staticRenderFns } from "./TariffTotalRow.vue?vue&type=template&id=2c5808d6&"
import script from "./TariffTotalRow.vue?vue&type=script&lang=js&"
export * from "./TariffTotalRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports